<template>
  <!--
    CommonHeader.vue
    顶部导航栏组件，包含Logo、主导航、用户信息、分类弹窗、搜索面板。
    采用BEM命名规范，支持响应式和交互。
  -->
  <div class="header">
    <!-- 顶部主容器 -->
    <div class="header__container" :style="{ minWidth: minWidth + 'px' }">
      <div class="header__content">
        <!-- 左侧Logo和主导航 -->
        <div class="header__left">
          <!-- Logo区域 -->
          <div class="header__logo">
            <img src="@/assets/newImage/heaader.png" alt="Logo" class="header__logo-image">
          </div>
          <!-- 主导航栏 -->
          <nav class="header__nav">
            <div 
              v-for="(tab, index) in tabs" 
              :key="index" 
              class="header__nav-item" 
              :class="{'header__nav-item--active': currentTabIndex === index}"
              @click="selectTab(index)"
              @mouseenter="handleTabHover(index)" 
              @mouseleave="handleTabLeave(index)"
            >
              <!-- 导航图标 -->
              <img 
                :src="currentTabIndex === index ? tab.activeIcon : tab.defaultIcon" 
                alt="tab icon" 
                class="header__nav-icon" 
              />
              <!-- 导航标题 -->
              <div class="header__nav-title">
                {{ tab.title }}
              </div>
            </div>
          </nav>
        </div>

        <!-- 右侧操作区：搜索、登录/用户信息 -->
        <div class="header__actions">
          <!-- 搜索按钮 -->
          <div class="header__search-trigger" @click.stop="toggleSearch">
            <i class="el-icon-search"></i>
            <span>搜索</span>
          </div>
          
          <!-- 未登录时显示注册/登录按钮 -->
          <el-button v-if="!userPhone" type="primary" @click="handleLogin">
            注册/登录
          </el-button>
          
          <!-- 已登录时显示用户信息和下拉菜单 -->
          <div v-else class="header__user">
            <!-- 用户头像 -->
            <img 
              class="header__user-avatar"
              src="https://km-renrenxiaoka-resource.oss-cn-shenzhen.aliyuncs.com/template/web/images/common/150-150.png"
              alt="avatar" 
            />
            <!-- 用户手机号，点击可进入个人中心，悬浮显示下拉菜单 -->
            <div 
              class="header__user-info" 
              @mouseenter="showUserMenu = true" 
              @click="navigateToUser"
            >
              {{ userPhone }}
              <!-- 用户菜单下拉框 -->
              <div 
                class="header__user-menu" 
                v-show="showUserMenu" 
                @click.stop="showUserMenu = false"
              >
                <!-- 用户基本信息 -->
                <div class="header__user-profile">
                  <img 
                    class="header__user-profile-avatar"
                    src="https://km-renrenxiaoka-resource.oss-cn-shenzhen.aliyuncs.com/template/web/images/common/150-150.png" 
                    alt="User avatar"
                  />
                  <div class="header__user-profile-details">
                    <div class="header__user-profile-phone">{{ userPhone }}</div>
                    <div class="header__user-profile-id">用户编号：{{ userId }}</div>
                  </div>
                </div>
                <!-- 用户菜单功能项 -->
                <div class="header__user-menu-items">
                  <div 
                    v-for="(item, index) in userMenuItems" 
                    :key="index"
                    class="header__user-menu-item" 
                    @click="goToUser(item.id)"
                  >
                    <span>{{ item.title }}</span>
                  </div>
                </div>
                <!-- 退出登录按钮 -->
                <div class="header__user-logout" @click="handleLogout">
                  <el-button type="primary">退出登录</el-button>
                </div>
              </div>
            </div>
            <!-- 下载图标 -->
            <img class="header__download-icon" src="../assets/image/下载 (4).png" alt="download" />
          </div>
        </div>
      </div>
    </div>
    
    <!-- 分类弹窗（鼠标悬浮"我要卖卡"时显示） -->
    <div 
      v-show="isPopupVisible" 
      class="header__categories" 
      @mouseenter="showPopup" 
      @mouseleave="hidePopup"
    >
      <div class="header__categories-grid">
        <div 
          v-for="category in productCategories" 
          :key="category.id"
          class="header__category-item" 
          :class="{'header__category-item--active': prodId === category.id}" 
          @click="onCategoryClick(category)"
        >
          <img 
            :src="imageBaseUrl + category.wapImg" 
            alt="" 
            class="header__category-image" 
          />
          <div class="header__category-title">{{ category.name }}</div>
        </div>
      </div>
    </div>
    
    <!-- 搜索面板 -->
    <div 
      class="header__search-panel" 
      v-if="showSearch" 
      @click.stop="handleSearchContainerClick"
    >
      <div class="header__search-input">
        <input 
          v-model="search" 
          type="text" 
          placeholder="请输入需要回收的卡券名称" 
          @keyup.enter="handleSearchClick"
        >
        <i class="el-icon-search" @click.stop="handleSearchClick"></i>
      </div>
      
      <div class="header__search-history">
        <!-- 历史搜索 -->
        <div class="header__search-section-header">
          <h3>历史搜索</h3>
          <i class="el-icon-delete-solid" @click="clearSearchHistory"></i>
        </div>
        <div class="header__search-tags">
          <el-tag 
            v-for="(tag, index) in historyTags" 
            :key="index"
            type="info" 
            closable 
            @close.stop="removeHistoryTag(tag)" 
            @click.stop="handleTagClick(tag.name)"
          >
            {{ tag.name }}
          </el-tag>
        </div>
        <!-- 热搜卡券 -->
        <div class="header__search-section-header">
          <h3>热搜卡券</h3>
        </div>
        <div class="header__search-tags">
          <el-tag 
            v-for="(tag, index) in hotTags" 
            :key="index" 
            type="info"
            @click="handleTagClick(tag.name)"
          >
            {{ tag.name }}
          </el-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import http from "@/utils/http/axios";

export default {
  name: 'CommonHeader',
  
  props: {
    // 默认激活的tab索引
    defaultIndex: {
      type: Number,
      default: 0,
    },
  },
  
  data() {
    return {
      minWidth: 1000, // 最小宽度
      search: '', // 搜索输入内容
      historyTags: [], // 历史搜索标签
      hotTags: [], // 热门卡券标签
      showSearch: false, // 是否显示搜索面板
      prodId: "", // 当前选中的分类ID
      imageBaseUrl: '', // 图片基础路径
      currentTabIndex: this.defaultIndex, // 当前激活tab索引
      hoveredTabIndex: -1, // 鼠标悬浮tab索引
      isPopupVisible: false, // 分类弹窗显示状态
      userPhone: '', // 用户手机号
      userId: '', // 用户ID
      showUserMenu: false, // 用户菜单显示状态
      productCategories: [], // 商品分类数据
      // 主导航tab配置
      tabs: [
        {
          title: "首页",
          defaultIcon: require("../assets/image/home1.png"),
          activeIcon: require("../assets/image/home2.png"),
          path: "/Home",
        },
        {
          title: "我要卖卡",
          defaultIcon: require("../assets/image/sales1.png"),
          activeIcon: require("../assets/image/sales2.png"),
          path: "/Sales",
        },
        {
          title: "商户合作",
          defaultIcon: require("../assets/image/sshanghu1.png"),
          activeIcon: require("../assets/image/shanghu2.png"),
          path: "/Cooperation",
        },
        {
          title: "邀请好友",
          defaultIcon: require("../assets/image/sshanghu1.png"),
          activeIcon: require("../assets/newImage/礼物 活动@2x.png"),
          path: "/Inviter",
        },
      ],
      // 用户菜单项配置
      userMenuItems: [
        { id: 3.1, title: "全部订单" },
        { id: 3.2, title: "批量订单" },
        { id: 2, title: "我要提现" },
        { id: 1, title: "账户流水" },
      ]
    };
  },
  
  created() {
    // 监听tab切换事件
    this.$bus.$on("changedTab", this.updateActiveTab);
  },
  
  mounted() {
    // 初始化历史搜索
    this.loadSearchHistory();
    // 监听历史搜索更新
    this.$bus.$on('updateCardCategory', this.updateSearchHistory);
    // 获取商品分类、用户信息、热门卡券
    this.fetchProductCategories();
    this.getUserInfo();
    this.fetchHotCategories();
    // 监听全局点击事件（用于关闭弹窗/菜单）
    document.addEventListener('click', this.handleGlobalClick);
  },
  
  beforeDestroy() {
    // 移除全局事件监听
    document.removeEventListener('click', this.handleGlobalClick);
    this.$bus.$off("changedTab", this.updateActiveTab);
    this.$bus.$off('updateCardCategory', this.updateSearchHistory);
  },
  
  methods: {
    /**
     * 选择主导航tab
     */
    selectTab(index) {
      this.isPopupVisible = false;
      this.currentTabIndex = index;
      this.$router.push(this.tabs[index].path);
    },
    /**
     * 跳转到用户中心
     */
    navigateToUser() {
      this.currentTabIndex = -1;
      this.$router.push("/user");
    },
    /**
     * 跳转到登录页
     */
    handleLogin() {
      this.$router.push("/login");
    },
    /**
     * 退出登录
     */
    handleLogout() {
      Cookie.remove('token');
      this.$router.push('/login');
    },
    /**
     * 用户菜单项点击，跳转到对应页面
     */
    goToUser(id) {
      this.showUserMenu = false;
      if (id === 3.1 || id === 3.2) {
        this.$store.commit('changedUserChildId', id);
      } else {
        this.$store.commit('changedUserChildId', id);
        this.$store.commit('changedUserId', id);
      }
      this.$router.push('/user');
    },
    /**
     * 鼠标悬浮tab时处理（显示分类弹窗）
     */
    handleTabHover(index) {
      if (index === 1) this.showPopup();
      this.hoveredTabIndex = index;
    },
    /**
     * 鼠标离开tab时处理
     */
    handleTabLeave() {
      // 保留接口，便于后续扩展
    },
    /**
     * 显示分类弹窗
     */
    showPopup() {
      this.isPopupVisible = true;
    },
    /**
     * 隐藏分类弹窗
     */
    hidePopup() {
      this.isPopupVisible = false;
    },
    /**
     * 分类点击事件，切换分类并跳转
     */
    onCategoryClick(category) {
      this.$bus.$emit("changedProdId", category.id);
      this.$store.commit("changedProdId", category.id);
      this.currentTabIndex = 1;
      this.isPopupVisible = false;
      this.$router.push("Sales");
    },
    /**
     * 切换搜索面板显示状态
     */
    toggleSearch() {
      this.showSearch = !this.showSearch;
    },
    /**
     * 搜索按钮点击，跳转到搜索页
     */
    handleSearchClick() {
      this.showSearch = false;
      this.$router.push({
        path: '/search',
        query: { search: this.search }
      });
      this.search = '';
    },
    /**
     * 点击标签进行搜索
     */
    handleTagClick(name) {
      this.showSearch = false;
      this.currentTabIndex = -1; 
      this.$router.push({
        path: '/search',
        query: { search: name }
      });
    },
    /**
     * 清空历史搜索
     */
    clearSearchHistory() {
      localStorage.removeItem("cardCategoryList");
      this.historyTags = [];
    },
    /**
     * 移除单个历史标签
     */
    removeHistoryTag(tag) {
      this.historyTags = this.historyTags.filter(item => item.id !== tag.id);
      localStorage.setItem("cardCategoryList", JSON.stringify(this.historyTags));
    },
    /**
     * 阻止搜索面板点击冒泡
     */
    handleSearchContainerClick(event) {
      event.stopPropagation();
    },
    /**
     * 全局点击事件处理（关闭弹窗/菜单）
     */
    handleGlobalClick() {
      this.showSearch = false;
      this.showUserMenu = false;
    },
    /**
     * 获取商品分类数据
     */
    async fetchProductCategories() {
      try {
        const response = await http.get("/product/type/list");
        if (response.code === 200) {
          this.productCategories = response.data.filter(item => item.type == 1);
        }
      } catch (error) {
        this.$message.error("获取分类数据失败");
      }
    },
    /**
     * 获取热门卡券数据
     */
    async fetchHotCategories() {
      try {
        const response = await http.get(`/product/product/list?prodTypeId=1`);
        if (response.code === 200) {
          this.hotTags = response.data.length > 8 ? response.data.slice(0, 7) : response.data;
        }
      } catch (error) {
        this.$message.error("获取热门卡券失败");
      }
    },
    /**
     * 获取用户信息
     */
    async getUserInfo() {
      try {
        const response = await http.get("/user/base/info");
        if (response.code === 200) {
          this.userPhone = response.data.mobile;
          this.userId = response.data.userId;
        }
      } catch (error) {
        console.error("获取用户信息失败", error);
      }
    },
    /**
     * tab切换事件监听
     */
    updateActiveTab(newValue) {
      this.currentTabIndex = newValue;
    },
    /**
     * 加载历史搜索标签
     */
    loadSearchHistory() {
      this.historyTags = JSON.parse(localStorage.getItem("cardCategoryList")) || [];
    },
    /**
     * 更新历史搜索标签
     */
    updateSearchHistory() {
      this.historyTags = JSON.parse(localStorage.getItem("cardCategoryList")) || [];
    }
  }
};
</script>

<style lang="less" scoped>
/*
  CommonHeader.vue 样式
  采用BEM命名规范，包含主导航、用户菜单、分类弹窗、搜索面板等样式
*/
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  
  &__container {
    height: 64px;
    background: white;
    width: 100%;
    position: relative;
    z-index: 9999;
    display: flex;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 0 17px;
  }
  
  &__content {
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
  }
  
  &__left {
    display: flex;
    align-items: center;
  }
  
  &__logo {
    margin-right: 120px;
    
    &-image {
      width: 122px;
    }
  }
  
  &__nav {
    display: flex;
    margin-left: 2px;
    
    &-item {
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s;
      margin-right: 50px;
      
      &:hover {
        color: #488eff;
      }
      
      &--active {
        color: #488eff;
      }
    }
    
    &-icon {
      width: 20px;
      height: 20px;
    }
    
    &-title {
      margin-left: 10px;
      color: inherit;
    }
  }
  
  &__actions {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  &__search {
    &-trigger {
      display: flex;
      align-items: center;
      cursor: pointer;
      
      span {
        margin-left: 5px;
      }
    }
    
    &-panel {
      position: fixed;
      top: 60px;
      right: 5vh;
      width: 500px;
      background: #fff;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
      padding: 15px;
      box-sizing: border-box;
      z-index: 9999;
    }
    
    &-input {
      display: flex;
      align-items: center;
      height: 50px;
      background-color: #f8f8fa;
      padding: 0 15px;
      border-radius: 5px;
      margin-bottom: 10px;
      
      input {
        flex: 1;
        background-color: transparent;
        border: none;
        outline: none;
        height: 100%;
        font-size: 14px;
      }
      
      i {
        cursor: pointer;
        font-size: 18px;
      }
    }
    
    &-history {
      padding: 10px 0;
    }
    
    &-section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      
      h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
      }
      
      i {
        cursor: pointer;
        font-size: 16px;
        color: #909399;
        
        &:hover {
          color: #f56c6c;
        }
      }
    }
    
    &-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 15px;
      
      .el-tag {
        cursor: pointer;
        margin-bottom: 5px;
      }
    }
  }
  
  &__user {
    display: flex;
    align-items: center;
    
    &-avatar {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
    
    &-info {
      padding: 0 10px;
      position: relative;
      cursor: pointer;
    }
    
    &-menu {
      position: absolute;
      top: 40px;
      right: 0;
      width: 300px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      padding: 20px;
      z-index: 1000;
    }
    
    &-profile {
      display: flex;
      align-items: center;
      padding-bottom: 20px;
      border-bottom: 1px solid #eee;
      
      &-avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 15px;
      }
      
      &-details {
        .header__user-profile-phone {
          font-size: 16px;
          font-weight: 500;
          color: #333;
          margin-bottom: 5px;
        }
        
        .header__user-profile-id {
          font-size: 14px;
          color: #999;
        }
      }
    }
    
    &-menu-items {
      padding: 10px 0;
    }
    
    &-menu-item {
      display: flex;
      align-items: center;
      padding: 12px 0;
      cursor: pointer;
      
      &:hover {
        background: #f5f7fa;
      }
      
      span {
        font-size: 14px;
        color: #333;
      }
    }
    
    &-logout {
      text-align: center;
      padding-top: 10px;
      border-top: 1px solid #eee;
      
      .el-button {
        width: 100%;
      }
    }
  }
  
  &__download-icon {
    width: 20px;
    height: 20px;
  }
  
  &__categories {
    position: fixed;
    top: 64px;
    left: 50%;
    width: 85%;
    transform: translateX(-50%);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 999;
    border-radius: 8px;
    visibility: visible;
    opacity: 1;
    transition: visibility 0s, opacity 0.2s linear;
    
    &-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 20px;
      background-color: white;
      border-radius: 10px;
      padding: 30px 40px 28px 36px;
      position: relative;
      box-sizing: border-box;
    }
  }
  
  &__category {
    &-item {
      background-color: #F3FBFF;
      border-radius: 13px;
      box-shadow: 0 0 10px #ccc;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 68px;
      cursor: pointer;
      transition: all 0.3s;
      
      &:hover {
        border: 1px solid #488eff;
        font-weight: 600;
        
        .header__category-image {
          animation: zoomBounce 0.5s ease-in-out;
        }
      }
      
      &--active {
        border: 1px solid #488eff;
      }
    }
    
    &-image {
      width: 40px;
      height: 40px;
      transition: transform 0.5s ease-in-out;
    }
    
    &-title {
      margin-left: 10px;
      font-size: 18px;
    }
  }
}

@keyframes zoomBounce {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.85);
  }
  75% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>

